import { React, useState, useEffect } from "react";
import "../components/styles/header.css";
import { Link } from 'react-router-dom';


function Nav(){
 const [theme, setTheme] = useState(() => {
   const savedTheme = localStorage.getItem('theme');
   if (savedTheme) return savedTheme;
   return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
 });

 const [isMenuOpen, setIsMenuOpen] = useState(false);

 useEffect(() => {
   document.documentElement.setAttribute('data-theme', theme);
   localStorage.setItem('theme', theme);
 }, [theme]);

 useEffect(() => {
   if (isMenuOpen) {
     document.body.style.overflow = 'hidden';
   } else {
     document.body.style.overflow = 'unset';
   }
   return () => {
     document.body.style.overflow = 'unset';
   };
 }, [isMenuOpen]);

 const toggleTheme = () => {
   setTheme(prev => prev === 'light' ? 'dark' : 'light');
 };

 const toggleMenu = () => {
   setIsMenuOpen(!isMenuOpen);
 };

 const closeMenu = () => {
   setIsMenuOpen(false);
 };

 return (
<>
  {isMenuOpen && <div className="overlay" onClick={closeMenu}></div>}
  <div className="nav">
    <Link to='/' className="logo-name">Ar.</Link>
    
    <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
      <span></span>
      <span></span>
      <span></span>
    </div>
    
    <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
    <li>
      <Link to="/usermanual" className="links" onClick={closeMenu}>About</Link>
    </li>
    <li>
      <Link to="/blogs" className="links" onClick={closeMenu}>Blogs</Link>
    </li>
    <li>
      <Link to="/skills" className="links" onClick={closeMenu}>Skills</Link>
    </li>
    <li>
      <Link to="/contact" className="links" onClick={closeMenu}>Contact</Link>
    </li>
    <li>
      <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle theme">
        {theme === 'light' ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="5"/>
            <line x1="12" y1="1" x2="12" y2="3"/>
            <line x1="12" y1="21" x2="12" y2="23"/>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
            <line x1="1" y1="12" x2="3" y2="12"/>
            <line x1="21" y1="12" x2="23" y2="12"/>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        )}
      </button>
    </li>
  </ul>
  </div>
</>
 )   
}

export default Nav;
